export default "__VITE_ASSET__CdG4ap4X__"